var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fetchAll = (fetchFunction, baseParameters = {}, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { batchSize = 1000 } = options;
    const allItems = [];
    let offset = 0;
    while (true) {
        const batchParameters = Object.assign(Object.assign({}, baseParameters), { limit: batchSize, offset });
        const response = yield fetchFunction(batchParameters);
        allItems.push(...response);
        if (response.length < batchSize) {
            break;
        }
        offset += batchSize;
    }
    return allItems;
});
